var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog205(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_205"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_205",
    "data-name": 205,
    className: "cls-2",
    d: "M50.63,5.06C39.45-1.29,24.2,1,17.92,15.27c-6,13.61,1.66,30.38,7.63,42.61C31.63,70.33,39,88.31,51.7,95.33c12.38,6.86,34.08,1.74,32.48-14.76C82.69,65.29,77.18,50.71,71,36.8,66.12,26,61.52,11.24,50.63,5.06Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog205);
export default __webpack_public_path__ + "static/media/dog_205.d71b61cb38dcbb736e172ff68854b074.svg";
export { ForwardRef as ReactComponent };